import React from 'react';
import { Link } from 'react-router-dom';
import { footerMenu } from '../../assets/dummyData/Menu';
import Logo from "../../assets/img/brand-logo.svg";
import "./style.css";
import Social from './Social';

const Footer = ({ activeClass }) => {
  const lang = "en";

  return (
    <footer id="main" className="container-custom-footer">
      <div className="left left-content around-content">
        <img src={Logo} alt="Captain Candy" className="brand-logo" />
        <div>
          <Social classProp="right around-content hidden-md hidden-lg" />
          <span className="copyright hidden-sm hidden-md">
              ©&nbsp;2023&nbsp;Captain&nbsp;Candy
          </span>
        </div>
      </div>
      <ul className='footer-menu'>
          {footerMenu[lang].map((el) => (
              <li
                  key={el.path} className={(activeClass === el.path) ? "active" : ""}
              >
                  <Link
                      onClick={() => {
                          window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                      }}
                      to={el.path}
                  >
                      {el.name}
                  </Link>
              </li>
          ))}
          <li
            className={(activeClass === '/presentation') ? "active" : ""}
          >
            <Link
              onClick={() => {
                  window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
              }}
              to="/presentation"
            >
              PDF
            </Link>
          </li>
      </ul>
      <Social classProp="right social-links around-content hidden-xs hidden-sm" />
    </footer>
  )
}

export default Footer;